<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="content p-5 table-responsive table-full-width">
                        <table class="table table-hover table-striped" *ngIf="history.length>0">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Score</th>
                                    <th *ngFor="let sub of subjectMaxArray; let i = index">Subject {{ i+1 }}</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let his of history">
                                    <td>{{this.util.formatDate(his.dateUTC)}}</td>
                                    <td>{{his.score | number}}</td>
                                    <td *ngFor="let sub of subjectMaxArray;let j = index">{{ getSubjectScore(his.subjects[j],his.subjectsScores) || '' }}
                                    </td>
                                    <td> <button class="btn btn-success" (click)="openAttemptScript(his)" [disabled]="disableButton" [style]="style.btnstyle">View Script</button></td>

                                </tr>
                            </tbody>
                        </table>
                        <p *ngIf="history.length==0"> No Attempts History</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>